<template>
    <div class="right-contx bgcolor-f6f5fa pull-right">
        <div class="top-titx font-16">账户信息</div>
        <div class="set-20180409-ccj">
            <div class="class-2019102801 font-14 clearfix other1">
                <el-tabs v-model="activeName" @tab-click="handleClick" type="border-card">
                    <el-tab-pane style="height: 600px;overflow: scroll;" name="1" label="全部">
                        <div v-if='flag' style="text-align: center;line-height: 450px;color: lightgray;">暂无订单信息</div>
                        <div v-for="(item,index) in orderList" :key="index" class="md-2019120501-xxw t">
                            <div class="md-hd"><span class="color-333">订单编号：{{item.sh_order_number}}</span><span
                                    class="time color-999">{{item.order_insert_time}}</span>
                                <p v-if="item.order_status == 1" class="pull-right color-blue js-typetext"
                                    style="color: red;">待支付</p>
                                <p v-if="item.order_status == 2" class="pull-right color-blue js-typetext">支付成功</p>
                                <p v-if="item.order_status == 3" class="pull-right color-blue js-typetext"
                                    style="color: red;">支付失败</p>
                                <p v-if="item.order_status == 4" class="pull-right color-blue js-typetext"
                                    style="color: red;">支付过期</p>
                            </div>
                            <div class="md-bd clearfix">
                                <div class="col-3-1206 clearfix md-19120602-xxw null">
                                    <div class="d1 pull-left"><img src="../../../../static/img/courseBack.jpg" alt=""><i
                                            class="state"></i>
                                    </div>
                                    <div class="text-box pull-left">
                                        <p class="p1 text-overflow font-16 color-333">{{item.order_commodityName}}</p>
                                        <p class="p3 color-333 font-18">￥{{item.order_amount}}</p>
                                    </div>
                                </div>
                                <div class="col-3-1206 col2">￥{{item.order_amount}}</div>
                                <div class="col-3-1206 col2">
                                    <v-button type="error" style="height: 30px;font-size: 15px;"
                                        @click="deleteOrder(item)">删除订单</v-button>
                                </div>
                            </div>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane style="height: 600px;overflow: scroll;" name="2" label="待支付">
                        <div v-if='flag' style="text-align: center;line-height: 450px;color: lightgray;">暂无订单信息</div>
                        <div v-for="(item,index) in orderList" :key="index" class="md-2019120501-xxw t">
                            <div class="md-hd"><span class="color-333">订单编号：{{item.wx_order_number}}</span><span
                                    class="time color-999">{{item.order_insert_time}}</span>
                                <p v-if="item.order_status == 1" class="pull-right color-blue js-typetext"
                                    style="color: red;">待支付</p>
                                <p v-if="item.order_status == 2" class="pull-right color-blue js-typetext">支付成功</p>
                                <p v-if="item.order_status == 3" class="pull-right color-blue js-typetext"
                                    style="color: red;">支付失败</p>
                                <p v-if="item.order_status == 4" class="pull-right color-blue js-typetext"
                                    style="color: red;">支付过期</p>
                            </div>
                            <div class="md-bd clearfix">
                                <div class="col-3-1206 clearfix md-19120602-xxw null">
                                    <div class="d1 pull-left"><img src="../../../../static/img/courseBack.jpg" alt=""><i
                                            class="state"></i>
                                    </div>
                                    <div class="text-box pull-left">
                                        <p class="p1 text-overflow font-16 color-333">{{item.order_commodityName}}</p>
                                        <p class="p3 color-333 font-18">￥{{item.order_amount}}</p>
                                    </div>
                                </div>
                                <div class="col-3-1206 col2">￥{{item.order_amount}}</div>
                                <div class="col-3-1206 col2">
                                    <v-button type="error" style="height: 30px;font-size: 15px;"
                                        @click="deleteOrder(item)">删除订单</v-button>
                                </div>
                            </div>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane style="height: 600px;overflow: scroll;" name="3" label="已完成">
                        <div v-if='flag' style="text-align: center;line-height: 450px;color: lightgray;">暂无订单信息</div>
                        <div v-for="(item,index) in orderList" :key="index" class="md-2019120501-xxw t">
                            <div class="md-hd"><span class="color-333">订单编号：{{item.wx_order_number}}</span><span
                                    class="time color-999">{{item.order_insert_time}}</span>
                                <p v-if="item.order_status == 1" class="pull-right color-blue js-typetext"
                                    style="color: red;">待支付</p>
                                <p v-if="item.order_status == 2" class="pull-right color-blue js-typetext">支付成功</p>
                                <p v-if="item.order_status == 3" class="pull-right color-blue js-typetext"
                                    style="color: red;">支付失败</p>
                                <p v-if="item.order_status == 4" class="pull-right color-blue js-typetext"
                                    style="color: red;">支付过期</p>
                            </div>
                            <div class="md-bd clearfix">
                                <div class="col-3-1206 clearfix md-19120602-xxw null">
                                    <div class="d1 pull-left"><img src="../../../../static/img/courseBack.jpg" alt=""><i
                                            class="state"></i>
                                    </div>
                                    <div class="text-box pull-left">
                                        <p class="p1 text-overflow font-16 color-333">{{item.order_commodityName}}</p>
                                        <p class="p3 color-333 font-18">￥{{item.order_amount}}</p>
                                    </div>
                                </div>
                                <div class="col-3-1206 col2">￥{{item.order_amount}}</div>
                                <div class="col-3-1206 col2">
                                    <v-button type="error" style="height: 30px;font-size: 15px;"
                                        @click="deleteOrder(item)">删除订单</v-button>
                                </div>
                            </div>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane style="height: 600px;overflow: scroll;" name="4" label="已失效">
                        <div v-if='flag' style="text-align: center;line-height: 450px;color: lightgray;">暂无订单信息</div>
                        <div v-for="(item,index) in orderList" :key="index" class="md-2019120501-xxw t">
                            <div class="md-hd"><span class="color-333">订单编号：{{item.wx_order_number}}</span><span
                                    class="time color-999">{{item.order_insert_time}}</span>
                                <p v-if="item.order_status == 1" class="pull-right color-blue js-typetext"
                                    style="color: red;">待支付</p>
                                <p v-if="item.order_status == 2" class="pull-right color-blue js-typetext">支付成功</p>
                                <p v-if="item.order_status == 3" class="pull-right color-blue js-typetext"
                                    style="color: red;">支付失败</p>
                                <p v-if="item.order_status == 4" class="pull-right color-blue js-typetext"
                                    style="color: red;">支付过期</p>
                            </div>
                            <div class="md-bd clearfix">
                                <div class="col-3-1206 clearfix md-19120602-xxw null">
                                    <div class="d1 pull-left"><img src="../../../../static/img/courseBack.jpg" alt=""><i
                                            class="state"></i>
                                    </div>
                                    <div class="text-box pull-left">
                                        <p class="p1 text-overflow font-16 color-333">{{item.order_commodityName}}</p>
                                        <p class="p3 color-333 font-18">￥{{item.order_amount}}</p>
                                    </div>
                                </div>
                                <div class="col-3-1206 col2">￥{{item.order_amount}}</div>
                                <div class="col-3-1206 col2">
                                    <v-button type="error" style="height: 30px;font-size: 15px;"
                                        @click="deleteOrder(item)">删除订单</v-button>
                                </div>
                            </div>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane style="height: 600px;overflow: scroll;" name="5" label="已关闭">
                        <div v-if='flag' style="text-align: center;line-height: 450px;color: lightgray;">暂无订单信息</div>
                        <div v-for="(item,index) in orderList" :key="index" class="md-2019120501-xxw t">
                            <div class="md-hd"><span class="color-333">订单编号：{{item.wx_order_number}}</span><span
                                    class="time color-999">{{item.order_insert_time}}</span>
                                <p v-if="item.order_status == 1" class="pull-right color-blue js-typetext"
                                    style="color: red;">待支付</p>
                                <p v-if="item.order_status == 2" class="pull-right color-blue js-typetext">支付成功</p>
                                <p v-if="item.order_status == 3" class="pull-right color-blue js-typetext"
                                    style="color: red;">支付失败</p>
                                <p v-if="item.order_status == 4" class="pull-right color-blue js-typetext"
                                    style="color: red;">支付过期</p>
                            </div>
                            <div class="md-bd clearfix">
                                <div class="col-3-1206 clearfix md-19120602-xxw null">
                                    <div class="d1 pull-left"><img src="../../../../static/img/courseBack.jpg" alt=""><i
                                            class="state"></i>
                                    </div>
                                    <div class="text-box pull-left">
                                        <p class="p1 text-overflow font-16 color-333">{{item.order_commodityName}}</p>
                                        <p class="p3 color-333 font-18">￥{{item.order_amount}}</p>
                                    </div>
                                </div>
                                <div class="col-3-1206 col2">￥{{item.order_amount}}</div>
                                <div class="col-3-1206 col2">
                                    <v-button type="error" style="height: 30px;font-size: 15px;"
                                        @click="deleteOrder(item)">删除订单</v-button>
                                </div>
                            </div>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        name: 'app',
        components: {

        },
        data() {
            return {
                activeName: '1',
                orderList: [],
                flag: false
            }
        },
        created() {
            this.$parent.Cut(this.$parent.list[2],2);
            //查询订单信息
            this.flag = false;
            this.loadData(this.activeName);

        },
        mounted() {

        },
        beforeDestroy() {

        },
        methods: {
            deleteOrder(item) {
                this.$confirm('此操作将永久删除该订单, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {

                    let parames = new URLSearchParams();
                    parames.append('id', item.id);
                    parames.append('type', 'delete');

                    //获取 当前等级下的上传资料 列表
                    this.$axios.post(this.serverUrl + '/order/operationOrder', parames).then(resp => {
                        if (resp.data.code === 1) {
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });

                            this.loadData(this.activeName);
                        }
                    }).catch(err => {
                        this.$message({
                            showClose: true,
                            message: '服务器繁忙，稍后重试！',
                            type: 'error'
                        });
                    })

                }).catch(() => {

                });

            },
            handleClick(tab, event) {
                this.loadData(this.activeName);
            },
            loadData(state) {

                this.flag = false;
                let parames = new URLSearchParams();
                parames.append('userId', this.$storage.get("declareUser").id);
                parames.append('orderType', 3);

                if (state != '1') {
                    parames.append('orderStatus', parseInt(state) - 1);
                }

                //获取 当前等级下的上传资料 列表
                this.$axios.post(this.serverUrl + '/order/getUserOrderData', parames).then(resp => {
                    if (resp.data.code === 1) {

                        if (resp.data.data.length > 0) {
                            this.orderList = resp.data.data;
                        } else {
                            this.flag = true;
                            this.orderList = [];
                        }
                    } else {
                        this.flag = true;
                    }
                }).catch(err => {
                    this.$message({
                        showClose: true,
                        message: '服务器繁忙，稍后重试！',
                        type: 'error'
                    });
                })

            }

        }
    }
</script>

<style scoped>
    div /deep/ button,
    input,
    select,
    textarea {
        font-family: inherit;
        font-size: inherit;
        line-height: initial;
        color: black;
    }

    .md-2019120501-xxw .col2 {
        width: 124px !important;
    }

    .md-2019120501-xxw .col2 {
        font-size: 24px;
        color: red;
        line-height: 106px;
        text-align: center;
        border: 1px dashed #dcdcdc;
        border-top: none;
        border-bottom: none;
        width: 168px;
    }

    .clearfix:after {
        clear: both;
        content: ".";
        display: block;
        font-size: 0;
        height: 0;
        line-height: 0;
        visibility: hidden;
    }

    .font-16 {
        font-size: 16px;
    }

    .text-overflow {
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .md-19120602-xxw .text-box>p {
        margin-bottom: 8px;
    }

    .md-19120602-xxw .text-box {
        width: 353px !important;
    }

    .md-19120602-xxw .text-box {
        width: 460px;
        padding-left: 30px;
    }

    .md-19120602-xxw .state,
    .md-2018040201-lty .pic-box .state {
        position: absolute;
        top: 0;
        left: 0;
        width: 44px;
        height: 44px;
        z-index: 2;
        display: none;
    }

    .md-2019120501-xxw .d1 img {
        height: 100%;
        width: 100%;
    }

    .md-19120602-xxw .d1 {
        width: 200px;
        height: 113px;
        position: relative;
        -webkit-border-radius: 6px 6px;
        -moz-border-radius: 6px 6px;
        border-radius: 6px 6px;
        overflow: hidden;
    }

    .md-19120602-xxw {
        position: relative;
    }

    .col-3-1206 {
        float: left;
    }

    .pull-right {
        float: right;
    }

    .color-blue {
        color: #4b95ff;
    }

    .color-999 {
        color: #999;
    }

    .md-2019120501-xxw>.md-hd .time {
        margin-left: 30px;
    }

    .color-333 {
        color: #333;
    }

    .cusfont-dingdan:before {
        content: "\e605";
    }

    .color-blue {
        color: #4b95ff;
    }

    .cusfont {
        font-family: "cusfont" !important;
        font-size: 16px;
        font-style: normal;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    .md-2019120501-xxw>.md-hd {
        border-bottom: 1px solid #ddd;
        line-height: 42px;
        margin-bottom: 20px;
    }

    .md-2019120501-xxw {
        padding: 5px 28px 20px;
        border-radius: 8px;
        overflow: hidden;
        box-shadow: 0 0 15px #eee;
        margin-bottom: 20px;
    }

    .cont-1206 {
        padding: 20px 30px;
    }

    #ddBox {
        min-height: 400px;
    }

    .clearfix:after {
        clear: both;
        content: ".";
        display: block;
        font-size: 0;
        height: 0;
        line-height: 0;
        visibility: hidden;
    }

    .titlex0 p {
        float: left;
        margin-bottom: -1px;
        text-align: center;
        line-height: 38px;
        padding: 0 8px;
        -webkit-border-radius: 4px 4px 0 0;
        -moz-border-radius: 4px 4px 0 0;
        border-radius: 4px 4px 0 0;
        cursor: pointer;
    }

    .titlex0 p.active {
        color: #fff;
        background: #4d95ff;
    }

    .class-2019102801.other1 .titlex0 p {
        padding: 0 25px;
    }

    .titlex0 {
        border-bottom: 1px solid #c9c9c9;
        font-size: 16px;
        color: #333;
        margin: 0 30px;
        padding: 30px 0 0;
    }

    .font-14 {
        font-size: 14px;
    }

    .class-2019102801 {
        background: #f6f5fa;
        margin-top: 16px;
        margin-bottom: 15px;
    }

    .class-2019102801.other1 {
        background: #fff;
    }

    .font-16 {
        font-size: 16px;
    }

    .font-16 {
        font-size: 16px;
    }

    .md-2018040807-xxw .top-titx {
        padding: 0 !important;
    }

    .md-2018040807-xxw .top-titx {
        line-height: 60px;
        padding: 0 28px;
        border-bottom: 1px solid #ddd;
    }

    .bgcolor-f6f5fa {
        background-color: unset !important;
    }

    .pull-right {
        float: right;
    }

    .bgcolor-f6f5fa {
        background: #f6f5fa;
    }

    .md-2018040807-xxw .right-contx {
        padding-bottom: 0 !important;
    }

    .md-2018040807-xxw .right-contx {
        width: 940px;
        min-height: 450px;
        padding-bottom: 34px;
        border-radius: 4px;
    }
</style>


// WEBPACK FOOTER //
// src/components/train/personalCenter/myAccount.vue